import {ObjectTypeId} from "../../../../../constants";
import {global} from "../../../../../appContext";
import {nsFa} from "../../../../fa/fn";
import {IRuleMutable} from "../index";
import {nsRule} from "../nsRule";
import i = nsFa.i;
import buttonsHtml from './buttons.html?raw';

export let template = buttonsHtml;

interface IParams {
    ruleMutable: IRuleMutable
    objectTypeId: ObjectTypeId
    objectTypeIds?: ObjectTypeId[]
    callback?: (val: any) => void
}

export class viewModel {
    private readonly ruleMutable: IRuleMutable;

    constructor(private params: IParams) {
        this.ruleMutable = params.ruleMutable;
    }

    private onEditExpressionClick() {
        global.dialogManager.addComponent({
            title: `${i('fa-pencil-ruler')} ((edit expression))`,
            content: {
                name: 'component/dynamic-variable/dialog/builder',
                params: {
                    expression: this.ruleMutable.argument,
                    objectTypeId: this.params.objectTypeId,
                    objectTypeIds: this.params.objectTypeIds,
                },
            }
        });
    }

    public doDialogPickObjectAttribute() {
        const callback = this.params.callback || ((val: any) => {
            this.ruleMutable.argument(val);
        });
        nsRule.doDialogPickObjectAttributeValue(callback, this.ruleMutable);
    }
}
